/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Images
import productImage from "assets/images/products/product-11.jpg";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { notificationActions } from "../../../../../../store/notification/notification-slice";

function EventImage({ formData, initialCover }) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { cover } = formField;
  const {
    cover: coverV,
  } = values;

  const [uploadCover, setUploadCover] = useState(null);
  const dispatch = useDispatch();
  useEffect(()=>{
    if(initialCover === coverV){
      setUploadCover(coverV);
    } else{
      setUploadCover(URL.createObjectURL(coverV));
    }
  },[])

  const handleCoverImage = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    const maxAllowedSize = 2 * 1024 * 1024;
    if (e.target.files[0].size > maxAllowedSize) {
      dispatch(notificationActions.showMessage({ message: "File is too big (max 2MB)", variant: "error" }));
    } else {
      setUploadCover(URL.createObjectURL(e.target.files[0]));
      setFieldValue("cover", e.target.files[0]);
    }
  };

  return (
    <Card
      sx={{
        "&:hover .card-header": {
          transform: "translate3d(0, -50px, 0)"
        }
      }}
    >
      <MDBox
        position="relative"
        borderRadius="lg"
        mt={-3}
        mx={2}
        className="card-header"
        sx={{ transition: "transform 300ms cubic-bezier(0.34, 1.61, 0.7, 1)" }}
      >
        <MDBox
          component="img"
          src={uploadCover}
          alt="Event Cover Image"
          borderRadius="lg"
          shadow="sm"
          width="100%"
          height="100%"
          position="relative"
          zIndex={10}
          mb={2}
        />
      </MDBox>
      <MDBox textAlign="center" pt={2} pb={3} px={3}>
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          mt={-10}
          position="relative"
          zIndex={1}
        >
          <input
            accept="image/png, image/jpeg"
            type="file"
            id="user-event-file"
            style={{ display: "none" }}
            onChange={handleCoverImage}
          />
          <MDBox mr={1}>
            <label htmlFor="user-event-file">
            <MDButton component="span" color="info" size="small">
              edit
            </MDButton>
            </label>
          </MDBox>
        </MDBox>
        <MDTypography variant="h5" fontWeight="regular" sx={{ mt: 4 }}>
          Event Cover Image
        </MDTypography>
      </MDBox>
    </Card>
  );
}

export default EventImage;
